import React, { useState, useEffect } from "react";
import { blogCategories } from "../GameServices/GameServices";

const useBlog = () => {
  const [data, setData] = useState([]);

  const fetchData = async () => {
    const { data } = await blogCategories();
    setData(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
  };
};

export default useBlog;
